import AbstractAsset from '@/editor/assets/abstract.asset';

export default class D1Asset extends AbstractAsset {
  constructor(uuid) {
    super(uuid);
    this._type = 'd1';
    this._props = {
      ...this._props,
      opacity: 1,
    };
    this._lastProps = {
      ...this._props,
      ...this._lastProps,
    };
  }

  get D() {
    return 1;
  }

  get PROPS() {
    return {
      opacity: {
        type: 'number',
        name: 'Opacity',
        normalized: true,
        slider: true,
        tool: 'OpacitySlider',
      },
    };
  }

    /*
  toolUpdate(update) {
    const ret = super.toolUpdate(update);
    if (update.tool === 'OpacitySlider') {
      ret.opacity = update.opacity;
    }
    return ret;
  }
  */
}
